import "./Introduction.css";
import config from "../config";

const Introduction = (props) => {
  let imageUrl = "/images/default-background.png";
  if (props.image !== undefined) {
    imageUrl = `${config.api}${props.image}`;
  }
  // kdybych chtel u prazdneho introduction menit transparentnost gradientu
  const transparency = props.text !== "" ? 0.8 : 0.8;

  return (
    <div
      className="container-fluid introduction-bg"
      style={{
        backgroundImage: `linear-gradient(0deg, rgba(255, 255, 255, ${transparency}) 0%, rgba(255, 255, 255, ${
          transparency - 0.3
        }) 100%), url('${imageUrl}')`,
      }}
    >
      <div className="container introduction d-flex flex-column justify-content-center align-items-center">
        <h1 className="text-center">{props.title}</h1>
        <h3 className="introduction-text text-center">{props.text}</h3>
      </div>
      <div className="section-divider"></div>
    </div>
  );
};
export default Introduction;
